<template lang="pug">
  .page.page-notes.pt-5.pb-5
    .container
      .row
        .col-sm-12
          h1 互動藝術程式創作入門 課程筆記
          br
        .col-sm-8
          p
            | 認識程式與互動藝術產業應用，開啟對工程跟設計的想像
            br
            | 學會使用 p5.js 開發互動介面，整合繪圖、音訊、視訊、文字、3D、互動與創作完整的作品
          p Hahow 課程連結：  
            a(href="https://hahow.in/cr/creative-coding-1") https://hahow.in/cr/creative-coding-1
        .col-sm-4
          p.text-right 講師： 墨雨設計 吳哲宇
            br
            | 課程管理： 墨雨設計 鄭安凱
            br
            | 聯繫我們： monoamestudio@gmail.com
      .toc
        .topic.p-4.mt-4(v-for='(chapter, index) in toc', :key='index')
          h3 {{ chapter.title }}
          .row.chapters
            router-link.chapter.col-md-6.col-sm-12.p-2.mt-1.animate__animated.animate__fadeIn(
              v-for='(section, index) in chapter.content', :key="index + '_'", 
              :to="{ name: 'NoteChap', params: { chapterNo: section['chapterNo'], hash: getHash(section['link']) } }")
              .inner-chapter.p-3
                .bkg(:style="{'background-image': 'url(' + section.image + ')'}")
                h2 {{ "Chapter " + section["chapterNo"] }}
                h4 {{ section["title"] }}

</template>

<script>
const visuals = [
  {
    title: "200529 Bubble Planet",
    isPjs: "2",
    description:
      "Testing new technique drawing mask layer and bg layer then combine with image masking function.\n\n[GIF https://media.giphy.com/media/QAxfMqa1mCr7Ix65d2/giphy.gif]",
    instructions: "",
    baseFolder: "",
    path: "",
    tags: [],
    license: "by-sa",
    imports: "",
    active: "1",
    isDraft: "0",
    isPrivate: "0",
    hideSourceCode: "0",
    isOnS3: "2020-05-30 00:01:12",
    url: null,
    createdOn: "2020-05-30 00:01:12",
    updatedOn: null,
    pinnedOn: "2020-05-30 00:10:49",
    filesUpdatedOn: null,
    thumbnailUpdatedOn: "2020-05-30 00:01:12",
    parentID: "0",
    engineID: "511",
    codeObjects: [],
    isArticle: "0",
    isTutorial: "0",
    hasFrameBorder: "1",
    loopProtect: "1",
    commentMode: "1",
    visualID: "907457",
    userID: "139364",
    isArchived: -1
  },
  {
    title: "200530 Mission Success",
    isPjs: "2",
    description:
      "In celebration of SpaceX's successful rocket launch! Made a rocket landing interaction with fire.\n[GIF https://media.giphy.com/media/jReOt7BJrxOmbtrvaE/giphy.gif]",
    instructions: "",
    baseFolder: "",
    path: "",
    tags: [],
    license: "by-sa",
    imports: "",
    active: "1",
    isDraft: "0",
    isPrivate: "0",
    hideSourceCode: "0",
    isOnS3: "2020-05-31 03:09:21",
    url: null,
    createdOn: "2020-05-31 03:09:21",
    updatedOn: null,
    pinnedOn: "2020-05-31 03:16:43",
    filesUpdatedOn: null,
    thumbnailUpdatedOn: "2020-05-31 03:09:21",
    parentID: "0",
    engineID: "511",
    codeObjects: [],
    isArticle: "0",
    isTutorial: "0",
    hasFrameBorder: "1",
    loopProtect: "1",
    commentMode: "1",
    visualID: "907972",
    userID: "139364",
    isArchived: -1
  },
  {
    title: "test spectrum centroid",
    isPjs: "2",
    description: "",
    instructions: "",
    baseFolder: "",
    path: "",
    tags: [],
    license: "by-sa",
    imports: "510",
    active: "1",
    isDraft: "0",
    isPrivate: "0",
    hideSourceCode: "0",
    isOnS3: "2020-06-01 01:32:04",
    url: null,
    createdOn: "2020-06-01 01:32:04",
    updatedOn: null,
    pinnedOn: null,
    filesUpdatedOn: null,
    thumbnailUpdatedOn: "2020-06-01 01:32:04",
    parentID: "0",
    engineID: "511",
    codeObjects: [],
    isArticle: "0",
    isTutorial: "0",
    hasFrameBorder: "1",
    loopProtect: "1",
    commentMode: "1",
    visualID: "908634",
    userID: "139364",
    isArchived: -1
  },
  {
    title: "taco",
    isPjs: "2",
    description: "",
    instructions: "",
    baseFolder: "",
    path: "",
    tags: [],
    license: "by-sa",
    imports: "",
    active: "1",
    isDraft: "0",
    isPrivate: "0",
    hideSourceCode: "0",
    isOnS3: "2020-06-01 11:06:25",
    url: null,
    createdOn: "2020-06-01 11:06:25",
    updatedOn: null,
    pinnedOn: null,
    filesUpdatedOn: null,
    thumbnailUpdatedOn: "2020-06-01 11:06:25",
    parentID: "908834",
    engineID: "511",
    codeObjects: [],
    isArticle: "0",
    isTutorial: "0",
    hasFrameBorder: "1",
    loopProtect: "1",
    commentMode: "1",
    visualID: "908964",
    userID: "139364",
    isArchived: -1
  },
  {
    title: "tacoII",
    isPjs: "2",
    description: "",
    instructions: "",
    baseFolder: "",
    path: "",
    tags: [],
    license: "by-sa",
    imports: "",
    active: "1",
    isDraft: "0",
    isPrivate: "0",
    hideSourceCode: "0",
    isOnS3: "2020-06-01 11:17:23",
    url: null,
    createdOn: "2020-06-01 11:17:23",
    updatedOn: null,
    pinnedOn: null,
    filesUpdatedOn: null,
    thumbnailUpdatedOn: "2020-06-01 11:17:23",
    parentID: "908891",
    engineID: "511",
    codeObjects: [],
    isArticle: "0",
    isTutorial: "0",
    hasFrameBorder: "1",
    loopProtect: "1",
    commentMode: "1",
    visualID: "908968",
    userID: "139364",
    isArchived: -1
  },
  {
    title: "mic test",
    isPjs: "2",
    description: "",
    instructions: "",
    baseFolder: "",
    path: "",
    tags: [],
    license: "by-sa",
    imports: "510",
    active: "1",
    isDraft: "0",
    isPrivate: "0",
    hideSourceCode: "0",
    isOnS3: "2020-06-01 16:27:23",
    url: null,
    createdOn: "2020-06-01 16:27:23",
    updatedOn: null,
    pinnedOn: null,
    filesUpdatedOn: "2020-06-01 16:28:36",
    thumbnailUpdatedOn: "2020-06-01 16:27:23",
    parentID: "0",
    engineID: "511",
    codeObjects: [],
    isArticle: "0",
    isTutorial: "0",
    hasFrameBorder: "1",
    loopProtect: "1",
    commentMode: "1",
    visualID: "909131",
    userID: "139364",
    isArchived: -1
  },
  {
    title: "mic 3d scope",
    isPjs: "2",
    description: "",
    instructions: "",
    baseFolder: "",
    path: "",
    tags: [],
    license: "by-sa",
    imports: "510",
    active: "1",
    isDraft: "0",
    isPrivate: "0",
    hideSourceCode: "0",
    isOnS3: "2020-06-01 16:51:42",
    url: null,
    createdOn: "2020-06-01 16:51:42",
    updatedOn: null,
    pinnedOn: null,
    filesUpdatedOn: null,
    thumbnailUpdatedOn: "2020-06-01 16:51:42",
    parentID: "0",
    engineID: "511",
    codeObjects: [],
    isArticle: "0",
    isTutorial: "0",
    hasFrameBorder: "1",
    loopProtect: "1",
    commentMode: "1",
    visualID: "909141",
    userID: "139364",
    isArchived: -1
  },
  {
    title: "test video mosaic",
    isPjs: "2",
    description: "",
    instructions: "",
    baseFolder: "",
    path: "",
    tags: [],
    license: "by-sa",
    imports: "",
    active: "1",
    isDraft: "0",
    isPrivate: "0",
    hideSourceCode: "0",
    isOnS3: "2020-06-01 17:34:43",
    url: null,
    createdOn: "2020-06-01 17:34:43",
    updatedOn: null,
    pinnedOn: null,
    filesUpdatedOn: null,
    thumbnailUpdatedOn: "2020-06-01 17:34:43",
    parentID: "0",
    engineID: "511",
    codeObjects: [],
    isArticle: "0",
    isTutorial: "0",
    hasFrameBorder: "1",
    loopProtect: "1",
    commentMode: "1",
    visualID: "909153",
    userID: "139364",
    isArchived: -1
  },
  {
    title: "camera test",
    isPjs: "2",
    description: "",
    instructions: "",
    baseFolder: "",
    path: "",
    tags: [],
    license: "by-sa",
    imports: "",
    active: "1",
    isDraft: "0",
    isPrivate: "0",
    hideSourceCode: "0",
    isOnS3: "2020-06-01 18:01:38",
    url: null,
    createdOn: "2020-06-01 18:01:38",
    updatedOn: null,
    pinnedOn: null,
    filesUpdatedOn: "2020-06-01 18:02:03",
    thumbnailUpdatedOn: "2020-06-01 18:01:38",
    parentID: "0",
    engineID: "511",
    codeObjects: [],
    isArticle: "0",
    isTutorial: "0",
    hasFrameBorder: "1",
    loopProtect: "1",
    commentMode: "1",
    visualID: "909161",
    userID: "139364",
    isArchived: -1
  },
  {
    title: "test color tracking",
    isPjs: "2",
    description: "",
    instructions: "",
    baseFolder: "",
    path: "",
    tags: [],
    license: "by-sa",
    imports: "",
    active: "1",
    isDraft: "0",
    isPrivate: "0",
    hideSourceCode: "0",
    isOnS3: "2020-06-01 18:44:07",
    url: null,
    createdOn: "2020-06-01 18:44:07",
    updatedOn: null,
    pinnedOn: null,
    filesUpdatedOn: null,
    thumbnailUpdatedOn: "2020-06-01 18:44:07",
    parentID: "0",
    engineID: "511",
    codeObjects: [],
    isArticle: "0",
    isTutorial: "0",
    hasFrameBorder: "1",
    loopProtect: "1",
    commentMode: "1",
    visualID: "909178",
    userID: "139364",
    isArchived: -1
  },
  {
    title: "200531 Glowing Mushroom",
    isPjs: "2",
    description:
      "The mushroom might be poisonous, be careful when you eat them.\n[GIF https://media.giphy.com/media/l522gSCMNr57SM8RKf/giphy.gif]",
    instructions: "",
    baseFolder: "",
    path: "",
    tags: [],
    license: "by-sa",
    imports: "",
    active: "1",
    isDraft: "0",
    isPrivate: "0",
    hideSourceCode: "0",
    isOnS3: "2020-06-01 22:23:10",
    url: null,
    createdOn: "2020-06-01 22:23:10",
    updatedOn: null,
    pinnedOn: "2020-06-01 23:13:02",
    filesUpdatedOn: null,
    thumbnailUpdatedOn: "2020-06-01 22:23:10",
    parentID: "0",
    engineID: "511",
    codeObjects: [],
    isArticle: "0",
    isTutorial: "0",
    hasFrameBorder: "1",
    loopProtect: "1",
    commentMode: "1",
    visualID: "909285",
    userID: "139364",
    isArchived: -1
  },
  {
    title: "200601 Chinese Mosaic",
    isPjs: "2",
    description:
      "Testing integrating the camera pixel and convert to Chinese words based on brightness.\n[GIF https://media.giphy.com/media/eIrMhOoMjLGtDccW8z/giphy.gif]",
    instructions: "",
    baseFolder: "",
    path: "",
    tags: [],
    license: "by-sa",
    imports: "",
    active: "1",
    isDraft: "0",
    isPrivate: "0",
    hideSourceCode: "0",
    isOnS3: "2020-06-02 01:56:33",
    url: null,
    createdOn: "2020-06-02 01:56:33",
    updatedOn: null,
    pinnedOn: "2020-06-02 02:04:45",
    filesUpdatedOn: null,
    thumbnailUpdatedOn: "2020-06-02 01:56:33",
    parentID: "909153",
    engineID: "511",
    codeObjects: [],
    isArticle: "0",
    isTutorial: "0",
    hasFrameBorder: "1",
    loopProtect: "1",
    commentMode: "1",
    visualID: "909343",
    userID: "139364",
    isArchived: -1
  },
  {
    title: "GrowShape",
    isPjs: "2",
    description: "",
    instructions: "",
    baseFolder: "",
    path: "",
    tags: [],
    license: "by-sa",
    imports: "",
    active: "1",
    isDraft: "0",
    isPrivate: "0",
    hideSourceCode: "0",
    isOnS3: "2020-06-02 12:17:28",
    url: null,
    createdOn: "2020-06-02 12:17:28",
    updatedOn: null,
    pinnedOn: null,
    filesUpdatedOn: null,
    thumbnailUpdatedOn: "2020-06-02 12:17:28",
    parentID: "0",
    engineID: "511",
    codeObjects: [],
    isArticle: "0",
    isTutorial: "0",
    hasFrameBorder: "1",
    loopProtect: "1",
    commentMode: "1",
    visualID: "909807",
    userID: "139364",
    isArchived: -1
  },
  {
    title: "200602 Test Glasses",
    isPjs: "2",
    description: "",
    instructions: "",
    baseFolder: "",
    path: "",
    tags: [],
    license: "by-sa",
    imports: "",
    active: "1",
    isDraft: "0",
    isPrivate: "0",
    hideSourceCode: "0",
    isOnS3: "2020-06-02 22:11:56",
    url: null,
    createdOn: "2020-06-02 22:11:56",
    updatedOn: null,
    pinnedOn: null,
    filesUpdatedOn: null,
    thumbnailUpdatedOn: "2020-06-02 22:11:56",
    parentID: "0",
    engineID: "511",
    codeObjects: [],
    isArticle: "0",
    isTutorial: "0",
    hasFrameBorder: "1",
    loopProtect: "1",
    commentMode: "1",
    visualID: "910130",
    userID: "139364",
    isArchived: -1
  },
  {
    title: "200602 Fish race",
    isPjs: "2",
    description:
      "The fish are hungry, please feed them or they will bite you.\n[GIF https://media.giphy.com/media/f6yUAOCOEIcS0iwTxr/giphy.gif]",
    instructions: "",
    baseFolder: "",
    path: "",
    tags: [],
    license: "by-sa",
    imports: "",
    active: "1",
    isDraft: "0",
    isPrivate: "0",
    hideSourceCode: "0",
    isOnS3: "2020-06-03 13:00:09",
    url: null,
    createdOn: "2020-06-03 13:00:09",
    updatedOn: null,
    pinnedOn: "2020-06-03 13:46:27",
    filesUpdatedOn: null,
    thumbnailUpdatedOn: "2020-06-03 13:00:09",
    parentID: "0",
    engineID: "511",
    codeObjects: [],
    isArticle: "0",
    isTutorial: "0",
    hasFrameBorder: "1",
    loopProtect: "1",
    commentMode: "1",
    visualID: "910854",
    userID: "139364",
    isArchived: -1
  },
  {
    title: "Test Tree Data Viz",
    isPjs: "2",
    description: "",
    instructions: "",
    baseFolder: "",
    path: "",
    tags: [],
    license: "by-sa",
    imports: "",
    active: "1",
    isDraft: "0",
    isPrivate: "0",
    hideSourceCode: "0",
    isOnS3: "2020-06-03 21:09:49",
    url: null,
    createdOn: "2020-06-03 21:09:49",
    updatedOn: null,
    pinnedOn: null,
    filesUpdatedOn: null,
    thumbnailUpdatedOn: "2020-06-03 21:09:49",
    parentID: "0",
    engineID: "511",
    codeObjects: [],
    isArticle: "0",
    isTutorial: "0",
    hasFrameBorder: "1",
    loopProtect: "1",
    commentMode: "1",
    visualID: "911120",
    userID: "139364",
    isArchived: -1
  },
  {
    title: "a lot of hi",
    isPjs: "2",
    description: "",
    instructions: "",
    baseFolder: "",
    path: "",
    tags: [],
    license: "by-sa",
    imports: "",
    active: "1",
    isDraft: "0",
    isPrivate: "0",
    hideSourceCode: "0",
    isOnS3: "2020-06-04 12:39:00",
    url: null,
    createdOn: "2020-06-04 12:39:00",
    updatedOn: null,
    pinnedOn: null,
    filesUpdatedOn: null,
    thumbnailUpdatedOn: "2020-06-04 12:39:00",
    parentID: "0",
    engineID: "511",
    codeObjects: [],
    isArticle: "0",
    isTutorial: "0",
    hasFrameBorder: "1",
    loopProtect: "1",
    commentMode: "1",
    visualID: "911622",
    userID: "139364",
    isArchived: -1
  },
  {
    title: "test json",
    isPjs: "2",
    description: "",
    instructions: "",
    baseFolder: "",
    path: "",
    tags: [],
    license: "by-sa",
    imports: "",
    active: "1",
    isDraft: "0",
    isPrivate: "0",
    hideSourceCode: "0",
    isOnS3: "2020-06-04 18:30:24",
    url: null,
    createdOn: "2020-06-04 18:30:24",
    updatedOn: null,
    pinnedOn: null,
    filesUpdatedOn: "2020-06-04 18:42:41",
    thumbnailUpdatedOn: "2020-06-04 18:30:24",
    parentID: "0",
    engineID: "511",
    codeObjects: [],
    isArticle: "0",
    isTutorial: "0",
    hasFrameBorder: "1",
    loopProtect: "1",
    commentMode: "1",
    visualID: "911804",
    userID: "139364",
    isArchived: -1
  },
  {
    title: "json test",
    isPjs: "2",
    description: "",
    instructions: "",
    baseFolder: "",
    path: "",
    tags: [],
    license: "by-sa",
    imports: "",
    active: "1",
    isDraft: "0",
    isPrivate: "0",
    hideSourceCode: "0",
    isOnS3: "2020-06-04 21:09:09",
    url: null,
    createdOn: "2020-06-04 21:09:09",
    updatedOn: null,
    pinnedOn: null,
    filesUpdatedOn: "2020-06-04 21:09:40",
    thumbnailUpdatedOn: "2020-06-04 21:09:09",
    parentID: "0",
    engineID: "511",
    codeObjects: [],
    isArticle: "0",
    isTutorial: "0",
    hasFrameBorder: "1",
    loopProtect: "1",
    commentMode: "1",
    visualID: "911913",
    userID: "139364",
    isArchived: -1
  },
  {
    title: "200603 Gravity Dance",
    isPjs: "2",
    description: "",
    instructions: "",
    baseFolder: "",
    path: "",
    tags: [],
    license: "by-sa",
    imports: "",
    active: "1",
    isDraft: "0",
    isPrivate: "0",
    hideSourceCode: "0",
    isOnS3: "2020-06-05 01:17:05",
    url: null,
    createdOn: "2020-06-05 01:17:05",
    updatedOn: null,
    pinnedOn: "2020-06-05 01:30:34",
    filesUpdatedOn: null,
    thumbnailUpdatedOn: "2020-06-05 01:17:05",
    parentID: "0",
    engineID: "511",
    codeObjects: [],
    isArticle: "0",
    isTutorial: "0",
    hasFrameBorder: "1",
    loopProtect: "1",
    commentMode: "1",
    visualID: "911988",
    userID: "139364",
    isArchived: -1
  },
  {
    title: "200604 Leaf Trap",
    isPjs: "2",
    description: "",
    instructions: "",
    baseFolder: "",
    path: "",
    tags: [],
    license: "by-sa",
    imports: "",
    active: "1",
    isDraft: "0",
    isPrivate: "0",
    hideSourceCode: "0",
    isOnS3: "2020-06-05 18:21:50",
    url: null,
    createdOn: "2020-06-05 18:21:50",
    updatedOn: null,
    pinnedOn: "2020-06-05 18:34:41",
    filesUpdatedOn: null,
    thumbnailUpdatedOn: "2020-06-05 18:21:50",
    parentID: "0",
    engineID: "511",
    codeObjects: [],
    isArticle: "0",
    isTutorial: "0",
    hasFrameBorder: "1",
    loopProtect: "1",
    commentMode: "1",
    visualID: "912547",
    userID: "139364",
    isArchived: -1
  },
  {
    title: "test dna",
    isPjs: "2",
    description: "",
    instructions: "",
    baseFolder: "",
    path: "",
    tags: [],
    license: "by-sa",
    imports: "",
    active: "1",
    isDraft: "0",
    isPrivate: "0",
    hideSourceCode: "0",
    isOnS3: "2020-06-06 01:51:34",
    url: null,
    createdOn: "2020-06-06 01:51:34",
    updatedOn: null,
    pinnedOn: null,
    filesUpdatedOn: null,
    thumbnailUpdatedOn: "2020-06-06 01:51:34",
    parentID: "0",
    engineID: "511",
    codeObjects: [],
    isArticle: "0",
    isTutorial: "0",
    hasFrameBorder: "1",
    loopProtect: "1",
    commentMode: "1",
    visualID: "912772",
    userID: "139364",
    isArchived: -1
  },
  {
    title: "test dots",
    isPjs: "2",
    description: "",
    instructions: "",
    baseFolder: "",
    path: "",
    tags: [],
    license: "by-sa",
    imports: "",
    active: "1",
    isDraft: "0",
    isPrivate: "0",
    hideSourceCode: "0",
    isOnS3: "2020-06-06 02:08:10",
    url: null,
    createdOn: "2020-06-06 02:08:10",
    updatedOn: null,
    pinnedOn: null,
    filesUpdatedOn: null,
    thumbnailUpdatedOn: "2020-06-06 02:08:10",
    parentID: "0",
    engineID: "511",
    codeObjects: [],
    isArticle: "0",
    isTutorial: "0",
    hasFrameBorder: "1",
    loopProtect: "1",
    commentMode: "1",
    visualID: "912777",
    userID: "139364",
    isArchived: -1
  },
  {
    title: "200605 Proton",
    isPjs: "2",
    description: "",
    instructions: "",
    baseFolder: "",
    path: "",
    tags: [],
    license: "by-sa",
    imports: "",
    active: "1",
    isDraft: "0",
    isPrivate: "0",
    hideSourceCode: "0",
    isOnS3: "2020-06-06 03:32:35",
    url: null,
    createdOn: "2020-06-06 03:32:35",
    updatedOn: null,
    pinnedOn: null,
    filesUpdatedOn: null,
    thumbnailUpdatedOn: "2020-06-06 03:32:35",
    parentID: "0",
    engineID: "511",
    codeObjects: [],
    isArticle: "0",
    isTutorial: "0",
    hasFrameBorder: "1",
    loopProtect: "1",
    commentMode: "1",
    visualID: "912811",
    userID: "139364",
    isArchived: -1
  },
  {
    title: "200605 Shiny CD",
    isPjs: "2",
    description: "",
    instructions: "",
    baseFolder: "",
    path: "",
    tags: [],
    license: "by-sa",
    imports: "",
    active: "1",
    isDraft: "0",
    isPrivate: "0",
    hideSourceCode: "0",
    isOnS3: "2020-06-06 04:02:51",
    url: null,
    createdOn: "2020-06-06 04:02:51",
    updatedOn: null,
    pinnedOn: "2020-06-06 04:04:30",
    filesUpdatedOn: null,
    thumbnailUpdatedOn: "2020-06-06 04:02:51",
    parentID: "0",
    engineID: "511",
    codeObjects: [],
    isArticle: "0",
    isTutorial: "0",
    hasFrameBorder: "1",
    loopProtect: "1",
    commentMode: "1",
    visualID: "912819",
    userID: "139364",
    isArchived: -1
  },
  {
    title: "200606 Gothic Script",
    isPjs: "2",
    description: "",
    instructions: "",
    baseFolder: "",
    path: "",
    tags: [],
    license: "by-sa",
    imports: "",
    active: "1",
    isDraft: "0",
    isPrivate: "0",
    hideSourceCode: "0",
    isOnS3: "2020-06-06 13:28:28",
    url: null,
    createdOn: "2020-06-06 13:28:28",
    updatedOn: null,
    pinnedOn: "2020-06-06 13:34:19",
    filesUpdatedOn: null,
    thumbnailUpdatedOn: "2020-06-06 13:28:28",
    parentID: "0",
    engineID: "511",
    codeObjects: [],
    isArticle: "0",
    isTutorial: "0",
    hasFrameBorder: "1",
    loopProtect: "1",
    commentMode: "1",
    visualID: "912976",
    userID: "139364",
    isArchived: -1
  },
  {
    title: "200607 Angry Puffer Fish",
    isPjs: "2",
    description: "",
    instructions: "",
    baseFolder: "",
    path: "",
    tags: [],
    license: "by-sa",
    imports: "510",
    active: "1",
    isDraft: "0",
    isPrivate: "0",
    hideSourceCode: "0",
    isOnS3: "2020-06-07 12:12:04",
    url: null,
    createdOn: "2020-06-07 12:12:04",
    updatedOn: null,
    pinnedOn: "2020-06-07 12:25:30",
    filesUpdatedOn: "2020-06-07 23:51:14",
    thumbnailUpdatedOn: "2020-06-07 12:12:04",
    parentID: "0",
    engineID: "511",
    codeObjects: [],
    isArticle: "0",
    isTutorial: "0",
    hasFrameBorder: "1",
    loopProtect: "1",
    commentMode: "1",
    visualID: "913327",
    userID: "139364",
    isArchived: -1
  },
  {
    title: "200608 Gaia's Tree",
    isPjs: "2",
    description: "",
    instructions: "",
    baseFolder: "",
    path: "",
    tags: [],
    license: "by-sa",
    imports: "",
    active: "1",
    isDraft: "0",
    isPrivate: "0",
    hideSourceCode: "0",
    isOnS3: "2020-06-09 19:43:34",
    url: null,
    createdOn: "2020-06-09 19:43:34",
    updatedOn: null,
    pinnedOn: "2020-06-09 23:01:25",
    filesUpdatedOn: null,
    thumbnailUpdatedOn: "2020-06-09 19:43:34",
    parentID: "0",
    engineID: "511",
    codeObjects: [],
    isArticle: "0",
    isTutorial: "0",
    hasFrameBorder: "1",
    loopProtect: "1",
    commentMode: "1",
    visualID: "914673",
    userID: "139364",
    isArchived: -1
  },
  {
    title: "200609 Causality",
    isPjs: "2",
    description: "",
    instructions: "",
    baseFolder: "",
    path: "",
    tags: [],
    license: "by-sa",
    imports: "",
    active: "1",
    isDraft: "0",
    isPrivate: "0",
    hideSourceCode: "0",
    isOnS3: "2020-06-11 06:08:43",
    url: null,
    createdOn: "2020-06-11 06:08:43",
    updatedOn: null,
    pinnedOn: "2020-06-11 06:15:02",
    filesUpdatedOn: null,
    thumbnailUpdatedOn: "2020-06-11 06:08:43",
    parentID: "0",
    engineID: "511",
    codeObjects: [],
    isArticle: "0",
    isTutorial: "0",
    hasFrameBorder: "1",
    loopProtect: "1",
    commentMode: "1",
    visualID: "915717",
    userID: "139364",
    isArchived: -1
  },
  {
    title: "explore state control",
    isPjs: "2",
    description: "",
    instructions: "",
    baseFolder: "",
    path: "",
    tags: [],
    license: "by-sa",
    imports: "",
    active: "1",
    isDraft: "0",
    isPrivate: "0",
    hideSourceCode: "0",
    isOnS3: "2020-06-12 10:39:12",
    url: null,
    createdOn: "2020-06-12 10:39:12",
    updatedOn: null,
    pinnedOn: null,
    filesUpdatedOn: null,
    thumbnailUpdatedOn: "2020-06-12 10:39:12",
    parentID: "0",
    engineID: "511",
    codeObjects: [],
    isArticle: "0",
    isTutorial: "0",
    hasFrameBorder: "1",
    loopProtect: "1",
    commentMode: "1",
    visualID: "916516",
    userID: "139364",
    isArchived: -1
  },
  {
    title: "layer draw",
    isPjs: "2",
    description: "",
    instructions: "",
    baseFolder: "",
    path: "",
    tags: [],
    license: "by-sa",
    imports: "",
    active: "1",
    isDraft: "0",
    isPrivate: "0",
    hideSourceCode: "0",
    isOnS3: "2020-06-12 11:10:13",
    url: null,
    createdOn: "2020-06-12 11:10:13",
    updatedOn: null,
    pinnedOn: null,
    filesUpdatedOn: null,
    thumbnailUpdatedOn: "2020-06-12 11:10:13",
    parentID: "0",
    engineID: "511",
    codeObjects: [],
    isArticle: "0",
    isTutorial: "0",
    hasFrameBorder: "1",
    loopProtect: "1",
    commentMode: "1",
    visualID: "916530",
    userID: "139364",
    isArchived: -1
  },
  {
    title: "test spectrum",
    isPjs: "2",
    description: "",
    instructions: "",
    baseFolder: "",
    path: "",
    tags: [],
    license: "by-sa",
    imports: "510",
    active: "1",
    isDraft: "0",
    isPrivate: "0",
    hideSourceCode: "0",
    isOnS3: "2020-06-12 12:00:24",
    url: null,
    createdOn: "2020-06-12 12:00:24",
    updatedOn: null,
    pinnedOn: null,
    filesUpdatedOn: null,
    thumbnailUpdatedOn: "2020-06-12 12:00:24",
    parentID: "0",
    engineID: "511",
    codeObjects: [],
    isArticle: "0",
    isTutorial: "0",
    hasFrameBorder: "1",
    loopProtect: "1",
    commentMode: "1",
    visualID: "916548",
    userID: "139364",
    isArchived: -1
  },
  {
    title: "partice sound test fork",
    isPjs: "2",
    description: "",
    instructions: "",
    baseFolder: "",
    path: "",
    tags: [],
    license: "by-sa",
    imports: "510",
    active: "1",
    isDraft: "0",
    isPrivate: "0",
    hideSourceCode: "0",
    isOnS3: "2020-06-12 12:09:15",
    url: null,
    createdOn: "2020-06-12 12:09:15",
    updatedOn: null,
    pinnedOn: null,
    filesUpdatedOn: null,
    thumbnailUpdatedOn: "2020-06-12 12:09:15",
    parentID: "913267",
    engineID: "511",
    codeObjects: [],
    isArticle: "0",
    isTutorial: "0",
    hasFrameBorder: "1",
    loopProtect: "1",
    commentMode: "1",
    visualID: "916553",
    userID: "139364",
    isArchived: -1
  },
  {
    title: "200610 Circular System",
    isPjs: "2",
    description: "",
    instructions: "",
    baseFolder: "",
    path: "",
    tags: [],
    license: "by-sa",
    imports: "",
    active: "1",
    isDraft: "0",
    isPrivate: "0",
    hideSourceCode: "0",
    isOnS3: "2020-06-12 16:27:57",
    url: null,
    createdOn: "2020-06-12 16:27:57",
    updatedOn: null,
    pinnedOn: "2020-06-12 16:35:36",
    filesUpdatedOn: null,
    thumbnailUpdatedOn: "2020-06-12 16:27:57",
    parentID: "0",
    engineID: "511",
    codeObjects: [],
    isArticle: "0",
    isTutorial: "0",
    hasFrameBorder: "1",
    loopProtect: "1",
    commentMode: "1",
    visualID: "916659",
    userID: "139364",
    isArchived: -1
  },
  {
    title: "200611 Fish Scales",
    isPjs: "2",
    description: "",
    instructions: "",
    baseFolder: "",
    path: "",
    tags: [],
    license: "by-sa",
    imports: "",
    active: "1",
    isDraft: "0",
    isPrivate: "0",
    hideSourceCode: "0",
    isOnS3: "2020-06-13 16:57:28",
    url: null,
    createdOn: "2020-06-13 16:57:28",
    updatedOn: null,
    pinnedOn: "2020-06-13 17:13:55",
    filesUpdatedOn: null,
    thumbnailUpdatedOn: "2020-06-13 16:57:28",
    parentID: "0",
    engineID: "511",
    codeObjects: [],
    isArticle: "0",
    isTutorial: "0",
    hasFrameBorder: "1",
    loopProtect: "1",
    commentMode: "1",
    visualID: "917010",
    userID: "139364",
    isArchived: -1
  },
  {
    title: "200612 Triangle Picnic",
    isPjs: "2",
    description: "",
    instructions: "",
    baseFolder: "",
    path: "",
    tags: [],
    license: "by-sa",
    imports: "",
    active: "1",
    isDraft: "0",
    isPrivate: "0",
    hideSourceCode: "0",
    isOnS3: "2020-06-14 09:57:59",
    url: null,
    createdOn: "2020-06-14 09:57:59",
    updatedOn: null,
    pinnedOn: "2020-06-14 09:59:34",
    filesUpdatedOn: null,
    thumbnailUpdatedOn: "2020-06-14 09:57:59",
    parentID: "0",
    engineID: "511",
    codeObjects: [],
    isArticle: "0",
    isTutorial: "0",
    hasFrameBorder: "1",
    loopProtect: "1",
    commentMode: "1",
    visualID: "917220",
    userID: "139364",
    isArchived: -1
  },
  {
    title: "200613 Crushing petals",
    isPjs: "2",
    description: "",
    instructions: "",
    baseFolder: "",
    path: "",
    tags: [],
    license: "by-sa",
    imports: "",
    active: "1",
    isDraft: "0",
    isPrivate: "0",
    hideSourceCode: "0",
    isOnS3: "2020-06-14 20:42:34",
    url: null,
    createdOn: "2020-06-14 20:42:34",
    updatedOn: null,
    pinnedOn: "2020-06-14 20:43:12",
    filesUpdatedOn: null,
    thumbnailUpdatedOn: "2020-06-14 20:42:34",
    parentID: "0",
    engineID: "511",
    codeObjects: [],
    isArticle: "0",
    isTutorial: "0",
    hasFrameBorder: "1",
    loopProtect: "1",
    commentMode: "1",
    visualID: "917383",
    userID: "139364",
    isArchived: -1
  },
  {
    title: "200615 Test Snake",
    isPjs: "2",
    description: "",
    instructions: "",
    baseFolder: "",
    path: "",
    tags: [],
    license: "by-sa",
    imports: "",
    active: "1",
    isDraft: "0",
    isPrivate: "0",
    hideSourceCode: "0",
    isOnS3: "2020-06-15 16:43:25",
    url: null,
    createdOn: "2020-06-15 16:43:25",
    updatedOn: null,
    pinnedOn: null,
    filesUpdatedOn: null,
    thumbnailUpdatedOn: "2020-06-15 16:43:25",
    parentID: "0",
    engineID: "511",
    codeObjects: [],
    isArticle: "0",
    isTutorial: "0",
    hasFrameBorder: "1",
    loopProtect: "1",
    commentMode: "1",
    visualID: "917734",
    userID: "139364",
    isArchived: -1
  },
  {
    title: "200614 Organic Circuit",
    isPjs: "2",
    description: "",
    instructions: "",
    baseFolder: "",
    path: "",
    tags: [],
    license: "by-sa",
    imports: "",
    active: "1",
    isDraft: "0",
    isPrivate: "0",
    hideSourceCode: "0",
    isOnS3: "2020-06-17 03:09:47",
    url: null,
    createdOn: "2020-06-17 03:09:47",
    updatedOn: null,
    pinnedOn: "2020-06-17 03:10:35",
    filesUpdatedOn: null,
    thumbnailUpdatedOn: "2020-06-17 03:09:47",
    parentID: "0",
    engineID: "511",
    codeObjects: [],
    isArticle: "0",
    isTutorial: "0",
    hasFrameBorder: "1",
    loopProtect: "1",
    commentMode: "1",
    visualID: "918427",
    userID: "139364",
    isArchived: -1
  },
  {
    title: "200615 Pink Radio",
    isPjs: "2",
    description: "",
    instructions: "",
    baseFolder: "",
    path: "",
    tags: [],
    license: "by-sa",
    imports: "",
    active: "1",
    isDraft: "0",
    isPrivate: "0",
    hideSourceCode: "0",
    isOnS3: "2020-06-18 14:24:55",
    url: null,
    createdOn: "2020-06-18 14:24:55",
    updatedOn: null,
    pinnedOn: "2020-06-18 14:39:38",
    filesUpdatedOn: null,
    thumbnailUpdatedOn: "2020-06-18 14:24:55",
    parentID: "0",
    engineID: "511",
    codeObjects: [],
    isArticle: "0",
    isTutorial: "0",
    hasFrameBorder: "1",
    loopProtect: "1",
    commentMode: "1",
    visualID: "919265",
    userID: "139364",
    isArchived: -1
  },
  {
    title: "200619 Test random vector field",
    isPjs: "2",
    description: "",
    instructions: "",
    baseFolder: "",
    path: "",
    tags: [],
    license: "by-sa",
    imports: "",
    active: "1",
    isDraft: "0",
    isPrivate: "0",
    hideSourceCode: "0",
    isOnS3: "2020-06-19 15:02:02",
    url: null,
    createdOn: "2020-06-19 15:02:02",
    updatedOn: null,
    pinnedOn: null,
    filesUpdatedOn: null,
    thumbnailUpdatedOn: "2020-06-19 15:02:02",
    parentID: "0",
    engineID: "511",
    codeObjects: [],
    isArticle: "0",
    isTutorial: "0",
    hasFrameBorder: "1",
    loopProtect: "1",
    commentMode: "1",
    visualID: "919862",
    userID: "139364",
    isArchived: -1
  },
  {
    title: "200616 Snail Racing",
    isPjs: "2",
    description:
      "Every Snail has it's own speed and unique patterns, it's okay to run slower than others.\n[GIF https://media.giphy.com/media/MZpqqkIOwN6orFLqS8/giphy.gif]",
    instructions: "",
    baseFolder: "",
    path: "",
    tags: [],
    license: "by-sa",
    imports: "",
    active: "1",
    isDraft: "0",
    isPrivate: "0",
    hideSourceCode: "0",
    isOnS3: "2020-06-19 20:07:42",
    url: null,
    createdOn: "2020-06-19 20:07:42",
    updatedOn: null,
    pinnedOn: "2020-06-19 20:19:58",
    filesUpdatedOn: null,
    thumbnailUpdatedOn: "2020-06-19 20:07:42",
    parentID: "0",
    engineID: "511",
    codeObjects: [],
    isArticle: "0",
    isTutorial: "0",
    hasFrameBorder: "1",
    loopProtect: "1",
    commentMode: "1",
    visualID: "919913",
    userID: "139364",
    isArchived: -1
  }
];

import { markdown } from "markdown";
import index from "@/assets/index.js";

export default {
  name: "Notes",
  components: {},
  data() {
    return {
      md: "",
      toc: index.index,
      visuals: visuals
    };
  },
  methods: {
    mdToHTML(md) {
      return markdown.toHTML(this.md);
    },
    getHash(url) {
      let devided = url.split("/");
      if (devided.length > 1) {
        return devided[devided.length - 1];
      } else {
        return "none";
      }
    },
    getThumbnail() {
      let nb = Math.floor(Math.random() * this.visuals.length);
      let visualId = this.visuals[nb].visualID;
      return `https://openprocessing-usercontent.s3.amazonaws.com/thumbnails/visualThumbnail${visualId}@2x.jpg`;
    }
  },
  created() {},
  mounted() {
    axios
      .get("https://hackmd.io/@ankycheng/creative-coding-intro/download")
      .then(res => {
        // console.log(res);
        this.md = res.data;
      });
    this.getThumbnail();
  }
};
</script>

<style lang="scss">
.page-notes {
  ul {
    list-style: none;
  }
  .topic {
    width: 100%;
    overflow: auto;
    border: solid 1px rgba(white,0.5);
    background-color: rgba(white,0.01);
    border-radius: 5px;
  }
  a:hover{
    text-decoration: none;
  }
  .chapters {
    position: relative;
    .inner-chapter {
      position: relative;
      min-height: 250px;
      border-radius: 5px;
      display: flex;
      flex-direction: column;
      justify-content: space-between;
      color: white;
      overflow: hidden;
      border: solid 1px rgba(white,0.2);
      text-shadow: 0px 0px 20px rgba(black,0.7);
      &:hover {
        text-decoration: none;
        background-size: 120%;
        transition-duration: 1s;
      }
      .bkg {
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        transition-duration: 0.5s;
        background-size: cover;
        background-position: center;
        background-repeat: no-repeat;
        
        &:hover {
          text-decoration-line: none;
          transform: scale(1.2);
          transition-duration: 0.5s;
          text-decoration: none;
          h4{
            background-color: #fff;
            color: black;
          }
        }
        &::after {
          content: "";
          width: 100%;
          height: 100%;
          position: absolute;
          left: 0;
          top: 0;
          background-color: rgba(black,0.2);
          transition: opacity 0.4s ease-in;
          z-index: 2;
          pointer-events: none;
        }
        &:hover::after {
          opacity: 0;
          transition: opacity 0.4s ease-in;
        }
      }
      h2,
      h4 {
        z-index: 5;
      }
      h2{
        font-weight: 700;
      }
      h4{
        background-color: black;
        padding: 5px;
        font-size: 18px;
        letter-spacing: 1px;
      }
    }
  }
  & > * {
    width: fit-content;
  }
  img {
    max-width: 100%;
  }
  & > * {
    pointer-events: auto;
  }
}


@media (max-width: 768px) {
  .notes {
    .toc {
      h2 {
        font-size: calc(12px + 3vw);
      }
      h4 {
        font-size: calc(8px + 3vw);
      }
      .chapters {
        flex-direction: column;
        .chapter {
          min-width: 90%;
        }
      }
    }
  }
}
</style>
